import React, {useEffect, useState} from "react";
import commonHeader from "../../assets/img/commonHeader.png";
import {useNavigate} from "react-router-dom";
import axios from '../../services/axiosInstance';
import {useTranslation} from "react-i18next";
import i18n from "../../i18n";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserNoticePg() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    const moveToDetail = ((seqNum) => {
        navigate(`/UserNoticeDtPg/${seqNum}`)
    })

    const [noticeList, setNoticeList] = useState([]);

    const selectAllNoticeList = (lang) => axios({
        method: 'get',
        url: '/notice/selectAllNoticeList/',
        params: {
            lang: lang
        }
    })
        .then((response) => {
            const data = response.data.sort((a, b) => b.seqNum - a.seqNum);
            setNoticeList(data);
        })

    const [currentLang, setCurrentLang] = useState(null);
    const currentLangUpdate = (() => {
        setCurrentLang(i18n.language || 'ko')
    })

    useEffect(() => {
        currentLangUpdate();
    }, [i18n.language]);

    useEffect(() => {
        let lang;
        if (currentLang === 'en') {
            lang = '1';
        } else if (currentLang === 'ja') {
            lang = '2';
        } else if (currentLang === 'zh') {
            lang = '3';
        } else if (currentLang === 'id') {
            lang = '4';
        } else {
            lang = '0';
        }
        selectAllNoticeList(lang);
    }, [currentLang]);

    useEffect(() => {
        currentLangUpdate();
    }, [i18n.language]);

        useEffect(() => {
            const selectAllNoticeList = (lang) => {
                switch (lang) {
                    case 'ko':
                        lang = '0';
                        break;
                    case 'en':
                        lang = '1';
                        break;
                    case 'ja':
                        lang = '2';
                        break;
                    case 'zh':
                        lang = '3';
                        break;
                    case 'id':
                        lang = '4';
                        break;
                    default:
                        lang = '0';
                }
                selectAllNoticeList(lang);
                i18n.on('languageChanged', selectAllNoticeList);
                return () => {
                    i18n.off('languageChanged', selectAllNoticeList);
                };
            }
        }, []);

    const formatDate = (dateStr) => {
        if (dateStr?.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    const fixedList = noticeList.filter(data => data.fixFl === true);
    const normalList = noticeList.filter(data => data.fixFl === false);

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" alt="notice" src={commonHeader}/>
                    <p className="up-head-title">{t(`NtHeader`)}</p> {/*공지사항*/}
                </div>
            </div>

            <div className="up-list up-scroll-x">
                <div className="up-scroll-inner">
                    <div className="up-thead">
                        <div className="c" style={{width: "15%"}}>{t(`fSmallMenu1`)}</div>
                        <div className="c" style={{width: "15%"}}>{t(`fSmallMenu5`)}</div>
                        <div className="c" style={{width: "55%"}}>{t(`fSmallMenu3`)}</div>
                        <div className="c" style={{width: "15%"}}>{t(`fSmallMenu4`)}</div>
                    </div>
                    <div className="up-tbody">
                        {fixedList.map((notice, i) => (
                            <div key={`fix-${i}`} onClick={() => moveToDetail(notice.seqNum)} className="up-trow">
                                <div className="c" style={{width: "15%"}}><span className="up-badge-fix">{t(`fdFix`)}</span></div>
                                <div className="c sub" style={{width: "15%"}}>{formatDate(notice?.regDate)}</div>
                                <div className="c title" style={{width: "55%"}}>{notice?.title}</div>
                                <div className="c sub" style={{width: "15%"}}>{notice?.regNm}</div>
                            </div>
                        ))}
                        {normalList.map((notice, i) => (
                            <div key={`n-${i}`} onClick={() => moveToDetail(notice.seqNum)} className="up-trow">
                                <div className="c sub" style={{width: "15%"}}>{i + 1}</div>
                                <div className="c sub" style={{width: "15%"}}>{formatDate(notice?.regDate)}</div>
                                <div className="c title" style={{width: "55%"}}>{notice?.title}</div>
                                <div className="c sub" style={{width: "15%"}}>{notice?.regNm}</div>
                            </div>
                        ))}
                        {noticeList.length === 0 &&
                            <div className="up-empty">{t(`NtHeader`)}</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserNoticePg
